export default __webpack_public_path__ + "assets/frischmann-component.9a018895.svg";